import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import {
  AlertController,
  ModalController,
  NavController,
} from '@ionic/angular';
import { GlobalVariable } from '../global';
import { ItemPreviewPage } from '../item-preview/item-preview.page';
import { SelectBranchPage } from '../select-branch/select-branch.page';
import { UserApiService } from '../services/user-api.service';
import { UserPointsPage } from '../user-points/user-points.page';

@Component({
  selector: 'app-my-rewards',
  templateUrl: './my-rewards.page.html',
  styleUrls: ['./my-rewards.page.scss'],
})
export class MyRewardsPage implements OnInit {
  // activeSeg='rewards';
  helper: any = [];
  rewardItems = [];
  bannerData: any;
  dealsOffers = [];
  isDataLoaded = false;
  pointPriceLabels = [];
  myRewards = [];
  punch_menu: any = [];
  punch_menu_flag: boolean = false;
  pointflag: boolean = false;
  punchflag: boolean = false;
  gain_flag: boolean = false;
  points_lotery: any;
  points_Status: any;
  points_reward: any;
  punch_reward: any;
  punchdata: any;
  punch_array: any;
  option: string;
  searchTerm: any = '';
  reward_array: any;
  rewarddata: any;
  flag: boolean = false;
  lotery: any;
  Status: any;
  gain_segment_flag: boolean = false;
  point_segment_flag: boolean = false;
  punchCard_segment_flag: boolean = false;
  gifts_segment_flag: boolean = false;
  arrayStatus: boolean = false;
  coordinates: any;

  // @ViewChild(Content) content: ElementRef
  public selected = 0;
  public indicator = null;
  mySlideOptions: any;
  data: any;
  reward: any;
  udid: any;
  img: any;
  status: boolean = true;
  time: any;
  // searchControl: FormControl;
  business_reward_data: any;
  business_reward_flag: boolean = false;
  redeem_history: boolean = false;
  rewards_length: any;
  point_menu = [];
  point_menu_flag: boolean = false;
  reward_menu = [];
  reward_menu_flag: boolean = false;

  reward_menu_length: any;
  reward_type_home: any;
  cart_reward_view: boolean = false;
  store_points: any;
  image_broken: any;
  sortdata: any = [];
  pointData: any;

  constructor(
    private router: Router,
    public globals: GlobalVariable,
    public server: UserApiService,
    public alertCtrl: AlertController,
    private modalCtrl: ModalController,
    private navCtrl: NavController
  ) {
    // if(this.globals.activeRewardsSegment=='deals'){
    //   this.special_offer_banners();

    // }
    this.point_items();
    this.getPoints();
    if (this.globals.activeRewardsSegment == 'my_rewards') {
      this.rewards_items();
    }
    if (this.globals.activeRewardsSegment == 'deals') {
      this.special_offer_banners();
    }
    if (this.globals.activeRewardsSegment == 'punches') {
      this.punch_cards();
    }
  }

  ngOnInit() {}
  segmentChanged(e) {
    this.globals.activeRewardsSegment = e.detail.value;
    if (this.globals.activeRewardsSegment == 'deals') {
      this.special_offer_banners();
    }
    if (this.globals.activeRewardsSegment == 'my_rewards') {
      this.rewards_items();
    }
    if (this.globals.activeRewardsSegment == 'punches') {
      this.punch_cards();
    }
  }
  convert(x) {
    if (x.includes(',')) {
      x = x.replace(',', '');
    }
    // console.log(Number(x))
    return Number(x);
  }
  buyDeal() {
    // this.router.navigate(['/tabs/tabs/menu'])
    if (this.globals.inWeb) {
      this.router.navigate(['/order']);
    } else {
      this.router.navigate(['/tabs/tabs/menu']);
    }
  }
  point_items() {
    this.isDataLoaded = false;
    this.sortingArray();

    let response = this.server.getpoints_menuitems();
    response.subscribe(
      (data) => {
        this.isDataLoaded = true;

        console.log(data);
        if (data.status == true) {
          this.rewardItems = data.items;
          this.rewardItems.forEach((subelement) => {
            subelement.quantity = 1;
            var result = subelement.point_price.replace(/,/g, '');
            subelement.rmstring = parseInt(result);
            if (Number(result) > Number(this.globals.points_)) {
              subelement.disable_btn = true;
            } else {
              subelement.disable_btn = false;
            }
            // console.log(this.rewardItems)
          });
          this.setup(this.rewardItems);
          this.helper.arr.multisort(this.rewardItems, ['rmstring'], ['ASC']);
        }
      },
      (error) => {
        // loading.dismiss();
        this.globals.presentToast(
          'Something went wrong check your internet connection.'
        );
      }
    );
  }
  sortingArray() {
    this.helper.arr = {
      multisort: function (arr, columns, order_by) {
        if (typeof columns == 'undefined') {
          columns = [];
          for (var x = 0; x < arr[0].length; x++) {
            columns.push(x);
          }
        }

        if (typeof order_by == 'undefined') {
          order_by = [];
          for (x = 0; x < arr[0].length; x++) {
            order_by.push('ASC');
          }
        }

        function multisort_recursive(a, b, columns, order_by, index) {
          var direction = order_by[index] == 'DESC' ? 1 : 0;

          var is_numeric = !isNaN(a[columns[index]] - b[columns[index]]);

          var x = is_numeric
            ? a[columns[index]]
            : a[columns[index]].toLowerCase();
          var y = is_numeric
            ? b[columns[index]]
            : b[columns[index]].toLowerCase();

          if (!is_numeric) {
            (x = this.helper.string.to_ascii(
              a[columns[index]].toLowerCase(),
              -1
            )),
              (y = this.helper.string.to_ascii(
                b[columns[index]].toLowerCase(),
                -1
              ));
          }

          if (x < y) {
            return direction == 0 ? -1 : 1;
          }

          if (x == y) {
            return columns.length - 1 > index
              ? multisort_recursive(a, b, columns, order_by, index + 1)
              : 0;
          }

          return direction == 0 ? 1 : -1;
        }

        return arr.sort(function (a, b) {
          return multisort_recursive(a, b, columns, order_by, 0);
        });
      },
    };
  }
  store_points_fun() {
    this.globals.presentToast(
      'You can avail this discount by adding items in cart.'
    );
  }
  // async points_buy_Confirm(id,type) {
  //   let alert = await this.alertCtrl.create({
  //     header: 'Purchase Item',
  //     message: 'Are you sure.You want to purchase item by points?',
  //     buttons: [
  //       {
  //         text: 'Cancel',
  //         role: 'cancel',
  //         handler: () => {
  //           console.log('Cancel clicked');
  //         }
  //       },
  //       {
  //         text: 'Buy',
  //         handler: () => {
  //           console.log('Buy clicked');
  //           this.redeem_point_menu_item(id,type);
  //         }
  //       }
  //     ]
  //   });
  //   await alert.present();
  // }

  async point_model(a) {
    const modal = await this.modalCtrl.create({
      component: UserPointsPage,
      breakpoints: [0, 0.8],
      initialBreakpoint: 0.8,
      mode: 'ios',
      cssClass: 'pointsModal',
      componentProps: {
        data: {
          title: 'Point Detail',
          terms: a.terms,
          image: a.image,
          name: a.name,
          tagline: a.points_description,
        },
      },
    });
    modal.present();
  }

  setup(rewards) {
    let pointsList = [];
    rewards.forEach((p) => {
      pointsList.push(p.point_price);
    });
    console.log('getting point price', pointsList);
    //  this.uniqBy(pointsList)
    //  pointsList.filter(e=>{

    //  })
    let uniqueChars = [...new Set(pointsList)];
    //  console.log('filter ',uniqueChars)
    //  this.pointPriceLabels=uniqueChars;
    let numVal = [];
    uniqueChars.forEach((e) => {
      numVal.push(this.convert(e));
    });
    numVal.sort((a, b) => {
      return a - b;
    });
    //  console.log('ss',numVal)

    numVal.forEach((e) => {
      e.toFixed(2);
      this.pointPriceLabels.push(String(e));
    });
    //  console.log('two hours later',this.pointPriceLabels)
  }

  //   showItems() {
  //     // this.showOtherOrders = true;
  //     // Get the container element
  // var btnContainer = document.getElementById("segment");

  // // Get all buttons with class="btn" inside the container
  // var btns = btnContainer.getElementsByClassName("items");

  // // Loop through the buttons and add the active class to the current/clicked button
  // for (var i = 0; i < btns.length; i++) {
  //   btns[i].addEventListener("click", function() {
  //     var current = document.getElementsByClassName("active");
  //     current[0].className = current[0].className.replace(" active", "");
  //     this.className += " active";
  //     // current[0].scrollIntoView({behavior:'smooth'})
  //   });
  // }

  //   }
  special_offer_banners() {
    this.isDataLoaded = false;
    let response = this.server.special_offer_banners();
    response.subscribe(
      (data) => {
        this.isDataLoaded = true;

        console.log('offers data ', data);
        this.bannerData = data;
        this.dealsOffers = this.bannerData.data;
        console.log('offers data ', this.dealsOffers);
      },
      (error) => {
        console.log(error);
        this.globals.presentToast('Something went wrong, try again');
      }
    );
  }
  async points_buy_Confirm(id, type, isDisable) {
    console.log(isDisable);
    if (isDisable == true) {
      this.globals.presentToast("You Don't have enough points to redeem");
      return;
    }
    let alert = await this.alertCtrl.create({
      header: 'Redeem Item',
      message: 'Are you sure.You want to redeem item by points?',
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          handler: () => {
            console.log('Cancel clicked');
          },
        },
        ,
        // {
        //   text: 'Add to cart',
        //   handler: () => {
        //     console.log('Buy clicked');
        //     // this.redeem_point_menu_item(id,type);
        //   }
        // }
        {
          text: 'Buy',
          handler: () => {
            console.log('Buy clicked');
            this.redeem_point_menu_item(id, type);
          },
        },
      ],
    });
    await alert.present();
  }
  redeem_point_menu_item(id, type) {
    let response = this.server.redeem_point_menu_reward(id, type);
    response.subscribe(
      (data) => {
        if (data.status == true) {
          this.globals.presentToast(data.message);
          this.getPoints();
          this.globals.activeRewardsSegment = 'my_rewards';
          // if(this.activeSeg=='my_rewards'){
          //   this.rewards_items();
          // }
          // this.punch_cards();
        } else {
          this.globals.presentToast(data.message);
        }
      },
      (error) => {
        // loading.dismiss();
        this.globals.presentToast(
          'Something went wrong check your internet connection.'
        );
      }
    );
  }
  getPoints() {
    this.server.getPoints().subscribe(
      (data) => {
        console.log('points data', data);
        if (data.status == 'error') {
          this.globals.points_ = 0;
        } else {
          this.globals.points_ = Number(data.rewards[0].points);
          this.store_points = data.rewards[0].available_rewards;
          console.log('store points ', this.store_points);

          // this.rewardItems = data.rewards[0].available_rewards;
          // console.log('re asign')

          // this.setup(this.rewardItems)
          // this.helper.arr.multisort(this.rewardItems, ['rmstring'], ['ASC']);
        }
      },
      (err) => {
        this.globals.presentToast('Network error!');
      }
    );
  }
  rewards_items() {
    this.isDataLoaded = false;
    this.myRewards = [];
    let response = this.server.getrewards_menuitems();
    response.subscribe(
      (data) => {
        this.isDataLoaded = true;
        console.log('my rew', data);
        if (data.status == true) {
          this.myRewards = data.items;
          // this.reward_menu_length = this.reward_menu.length;
          this.myRewards.forEach((subelement) => {
            subelement.quantity = 1;
          });
        }
      },
      (error) => {
        this.globals.presentToast(
          'Something went wrong check your internet connection.'
        );
      }
    );
  }

  branchSelection() {}

  async openItem(menuitem, extras, reward_id) {
    this.globals.businessMenuItem = menuitem;
    this.globals.itemDetail = menuitem;

    let activeBranch = localStorage.getItem('activeBranchid');
    if (this.globals.branch_enabled == 1 && !activeBranch) {
      let modal = await this.modalCtrl.create({
        component: SelectBranchPage,
        cssClass: 'branch_modal',
        mode: 'ios',
        componentProps: { ismodal: true },
      });
      modal.present();
      modal.onDidDismiss().then(async (res) => {
        console.log(res);
        if (res.data) {
          const modal = await this.modalCtrl.create({
            component: ItemPreviewPage,
            cssClass: 'item+itemPreviewPage',
            componentProps: {
              data: menuitem,
              extrasObtained: extras,
              reward_id_new: reward_id,
              reward_flag: true,
            },
          });

          await modal.present();

          const data = await modal.onDidDismiss();
          console.log(data);
        }
      });

      //branchc case
    } else {
      //normal case
      const modal = await this.modalCtrl.create({
        component: ItemPreviewPage,
        componentProps: {
          data: menuitem,
          extrasObtained: extras,
          reward_id_new: reward_id,
          reward_flag: true,
        },
      });

      await modal.present();

      const data = await modal.onDidDismiss();
      console.log(data);
    }

    //  this.router.navigate(['/item-preview']);
  }

  openCart() {
    if (
      this.globals.itemsInCart.length > 0 &&
      this.globals.branch_enabled == 1 &&
      this.globals.franchise_enabled == false
    ) {
      //if corporate and cart has items  change business data before switch

      this.globals.businessData = this.globals.tempPlace;

      this.globals.setupBusiness(this.globals.businessData);
      this.navCtrl.navigateRoot('new-cart');
    } else {
      this.navCtrl.navigateRoot('new-cart');
    }
  }
  punch_cards() {
    this.isDataLoaded = false;

    this.server.getpunches_menuitems().subscribe(
      (data) => {
        this.isDataLoaded = true;

        if (data.status == true) {
          this.punch_menu = data.items;
          if (this.punch_menu.length == 0) {
            this.punch_menu_flag = true;
          } else {
            this.punch_menu_flag = false;
          }
          console.log('Punches ', this.punch_menu);
          var i = 0;
          var percent = 0;
          var that = this;
          setTimeout(() => {
            that.punch_menu.forEach((element) => {
              percent =
                (Number(element.punch_count) / Number(element.punch_limit)) *
                100;
              that.globals.circle_graph(percent, 'circles' + i, 55, 8, '#ccc');

              console.log(percent, 'circles' + i);
              i++;
            });
          }, 1200);
        }
      },
      (err) => {
        this.isDataLoaded = true;

        this.globals.presentToast('Network error!');
      }
    );
  }
  async punch_model(rewards) {
    // let modal = this.modalCtrl.create('PointPunchModelPage', { title: "Punch Detail",terms:rewards.terms,tagline:rewards.punch_description, udid:rewards.id, name:rewards.name, image: rewards.image, punch_count: rewards.punch_count, punch_limit: rewards.punch_limit});

    const modal = await this.modalCtrl.create({
      component: UserPointsPage,
      breakpoints: [0, 0.8],
      initialBreakpoint: 0.8,
      mode: 'ios',
      cssClass: 'pointsModal',
      componentProps: {
        data: {
          title: 'Punch Detail',
          terms: rewards.terms,
          tagline: rewards.punch_description,
          udid: rewards.id,
          name: rewards.name,
          image: rewards.image,
          punch_count: rewards.punch_count,
          punch_limit: rewards.punch_limit,
        },
      },
    });
    modal.present();
  }
}
